import { dashboardConstants, globalConstants, projectConstants } from "../../constants";

//Destructuring global constants
const { SUCCESS } = globalConstants;

//Default state of admin reducer
const initialState = {
  data: [],
  recruiterStats: [],
  formData: {},
};
//Manipulating the state of admin portal based on actions and returning the state
export const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case dashboardConstants.GET_DASHBOARD_STATS + SUCCESS:
      return { ...state, data: action.data };
    case dashboardConstants.GET_DASHBOARD_RECRUITER_STATS + SUCCESS:
      return { ...state, recruiterStats: action.data };
    case projectConstants.GET_PROJECT_BY_ID + SUCCESS:
      return { ...state, formData: action.data };
    default:
      return state;
  }
};
